'use client'

import { useEffect } from 'react'

interface FusedeckTrackingProps {
  idFusedeck: string
}

export default function FusedeckTracking({
  idFusedeck
}: FusedeckTrackingProps) {
  useEffect(() => {
    try {
      console.log('Fusedeck is loading...')
      let c: string | null = null
      let k: string | null = null

      // Parse cookies
      const cookies = document.cookie.split(';')
      cookies.forEach((cookie) => {
        const [key, value] = cookie.trim().split('=')
        if (key === `fdTrackingType${idFusedeck}`) {
          c = value
        }
        if (key === 'fdEnvId') {
          k = value
        }
      })

      // Construct script source URL
      const src = `https://io.fusedeck.net/d/tm.js?p=${idFusedeck}&l=${''}${
        c ? `&c=${c}` : ''
      }${k ? `&e=${k}` : ''}&h=${encodeURIComponent(window.location.href)}`

      // Inject the script into the document
      const script = document.createElement('script')
      script.async = true
      script.src = src
      document.head.appendChild(script)

      script.onload = () => console.log('Fusedeck script loaded successfully.')
      script.onerror = () => console.error('Fusedeck script failed to load.')
    } catch (error) {
      console.error('Error initializing Fusedeck tracking:', error)
    }
  }, [idFusedeck])

  return <></> // No visible UI, only script injection
}
